import { createReducer } from 'redux-act';
import * as actions from '#app/actions/trade';

interface TradeState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  notificationIds: unknown[];
}

const initialState: TradeState = {
  modalVisible: false,
  form: {},
  notificationIds: [],
};

const setTradeModalVisible = (state: TradeState, bool: boolean): TradeState => ({
  ...state,
  modalVisible: bool,
});

const closeTradeForm = (state: TradeState): TradeState => ({
  ...state,
  form: {},
  modalVisible: false,
  notificationIds: [],
});

const setTradeForm = (state: TradeState, form: Record<string, unknown>): TradeState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const setNotificationIds = (state: TradeState, ids: unknown[]): TradeState => ({
  ...state,
  notificationIds: ids,
});

export default createReducer<TradeState>(
  {
    [actions.setTradeModalVisible as any]: setTradeModalVisible,
    [actions.setTradeForm as any]: setTradeForm,
    [actions.closeTradeForm as any]: closeTradeForm,
    [actions.setNotificationIds as any]: setNotificationIds,
  },
  initialState
);
